import type { Content } from '@plone/types';
import { Message } from '@designsystem/stories/03-molecules/Message';
import { sanitizeLinksOnly } from '@designsystem/utils/sanitize';

interface ApplicationMessageProps {
  content: Content;
  hasOccasions: boolean;
}

/**
 * Component for Application info messages
 * Shows active/inactive messages based on occasions
 */
export const ApplicationMessage = ({
  content,
  hasOccasions,
}: ApplicationMessageProps) => {
  const hasInfoMessage = hasOccasions
    ? content?.application_infotext_active
    : content?.application_infotext_inactive;

  const hasNote = content?.application_note;

  // Render nothing if no content to display
  if (!hasInfoMessage && !hasNote) {
    return null;
  }

  return (
    <>
      {hasInfoMessage && <Message type="info" title={hasInfoMessage} />}
      {hasNote && (
        <p
          className="application-note"
          dangerouslySetInnerHTML={{
            __html: sanitizeLinksOnly(hasNote),
          }}
        />
      )}
    </>
  );
};
